import { find } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  MenuInfo,
  PageInfo,
  PAGE_INFO_MAP,
} from '../../constants/pageInfo';

const findPortal = (currentUrl: string) => find(PAGE_INFO_MAP, (v) => currentUrl.startsWith(v.url));
const findMenu = (pageInfo: PageInfo, currentUrl: string) => (
  find(pageInfo.menu, (v) => currentUrl.startsWith(v.url))
);

export const useUrlBasedTitle = () => {
  const { pathname } = useLocation();
  const [pageInfo, setPageInfo] = useState<PageInfo>();
  const [menuInfo, setMenuInfo] = useState<MenuInfo>();

  const findMenuInfoById = (id: string) => (
    find(pageInfo?.menu, (v) => v.id === id)
  );

  useEffect(() => {
    const p = findPortal(pathname);
    if (p) {
      const m = findMenu(p, pathname);
      setPageInfo(p);
      if (m) {
        setMenuInfo(m);
      }
    }
  }, [pathname]);

  const result = useMemo(() => ({
    pageInfo,
    menuInfo,
    findMenuInfoById,
  }), [pageInfo, menuInfo]);

  return result;
};
